module.exports = __webpack_public_path__ + "media/tizi.b0ec20b3.mp3";